import ShopContent from "./ShopPage/ShopContent";
import ShopHeader from "./ShopPage/ShopHeader";

function Shop() {
  return (
    <>
      <ShopHeader />
      <ShopContent />
    </>
  );
}

export default Shop;
